import { render, staticRenderFns } from "./dossier.vue?vue&type=template&id=d880d512&"
import script from "./dossier.ts?vue&type=script&lang=ts&"
export * from "./dossier.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports